import { Fragment, useMemo } from "react";
import { useTranslation } from "react-i18next";
import type { GridReviewHintItem, GridReviewHintProps } from "./types";

export const GridReviewHint = ({ isSelectable }: GridReviewHintProps) => {
  const { t } = useTranslation();

  const hintItems = useMemo<GridReviewHintItem[]>(() => {
    const openItem: GridReviewHintItem = {
      shortcut: t("smartSurveyor.gridReview.hintDoubleClickKey"),
      label: t("smartSurveyor.gridReview.hintDoubleClickLabel"),
    };
    if (!isSelectable) {
      return [openItem];
    }
    return [
      {
        shortcut: t("smartSurveyor.gridReview.hintClickKey"),
        label: t("smartSurveyor.gridReview.hintClickLabel"),
      },
      {
        shortcut: t("smartSurveyor.gridReview.hintShiftClickKey"),
        label: t("smartSurveyor.gridReview.hintShiftClickLabel"),
      },
      openItem,
    ];
  }, [isSelectable, t]);

  return (
    <div className="flex flex-wrap items-center gap-x-3 gap-y-1 text-xs text-gray-500">
      {hintItems.map((item, itemIndex) => (
        <Fragment key={item.shortcut}>
          {itemIndex > 0 && (
            <span aria-hidden className="h-3.5 w-px bg-gray-300" />
          )}
          <span className="flex items-center gap-1.5">
            <kbd className="rounded border border-gray-200 bg-gray-100 px-1.5 py-px font-mono text-xs leading-none text-gray-700">
              {item.shortcut}
            </kbd>
            <span>{item.label}</span>
          </span>
        </Fragment>
      ))}
    </div>
  );
};
